import React from 'react'

// components
import FormSeo from '../../FormComponents/FormSeo'

export default function SeoTab(props) {
    // props
    const {
        formik,
        allowedMetaTitleLength,
        allowedMetaDescLength
    } = props

    return (
        <React.Fragment>
            {/* images */}
            <FormSeo
                formik={formik}

                allowedMetaTitleLength={allowedMetaTitleLength}
                allowedMetaDescLength={allowedMetaDescLength}
            />
        </React.Fragment>
    )
}
